import React from "react";
import { cva, type VariantProps } from "class-variance-authority";

const labelVariants = cva(
  "text-sm font-medium transition-colors duration-200 block",
  {
    variants: {
      color: {
        purple: "text-black",
        yellow: "text-black",
        dark: "text-white",
      },
      disabled: {
        true: "opacity-50 cursor-not-allowed",
        false: "",
      },
    },
    defaultVariants: {
      color: "purple",
      disabled: false,
    },
  }
);

export interface LabelProps
  extends
    Omit<React.LabelHTMLAttributes<HTMLLabelElement>, "color">,
    VariantProps<typeof labelVariants> {
  /** Additional CSS classes */
  className?: string;
}

/**
 * Generic Label component for form elements.
 * Supports theme variants and disabled states.
 */
export const Label: React.FC<LabelProps> = ({
  color,
  disabled,
  className,
  children,
  ...props
}) => {
  return (
    <label className={labelVariants({ color, disabled, className })} {...props}>
      {children}
    </label>
  );
};
